class Headers {
  constructor($pool, $plugins, tableName) {
    this.cells = {}
    this.node = null
    this.name = tableName

    this.$pool = $pool
    this.$plugins = $plugins
  }

  connect(node, headers) {
    this.cells = headers
    this.node = node

    return this
  }
}

export default Headers
